"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerDay = exports.DAY_STYLED_CLASS_NAME = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _typography = require("../../../typography");
var _DatePickerDayButtonStyled = require("../styled/DatePickerDayButtonStyled");
var _datePickerTheme = require("../styled/datePickerTheme");
const DAY_STYLED_CLASS_NAME = "lodestar-core--date-picker--day-h3kj2h1";
exports.DAY_STYLED_CLASS_NAME = DAY_STYLED_CLASS_NAME;
const DatePickerDay = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_DatePickerDayButtonStyled.DatePickerDayButtonStyled, (0, _extends2.default)({}, rest, {
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_typography.TypeRampV2, (0, _extends2.default)({
    className: DAY_STYLED_CLASS_NAME
  }, (0, _datePickerTheme.getTypeRampPropsDay)(rest.themeMode)), children));
});
exports.DatePickerDay = DatePickerDay;
DatePickerDay.displayName = "DatePickerDay";
//# sourceMappingURL=DatePickerDay.js.map